module.exports = __webpack_public_path__ + "assets/img/product_aspirin@2x.1a366b41.jpg";